export const RadarLanguage = [
  {
    name: 'English',
    code: 'en-US',
    flag: 'US',
    direction: 'ltr',
    label: 'English'
  }
]
